import JwtDecode from 'jwt-decode'

export default class User {
  static from(token) {
    try {
      let obj = JwtDecode(token)
      return new User({
        sub: obj.sub,
        email: obj.email,
        firstName: obj.given_name || "",
        roles: obj["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"] || "",
        admin: (obj["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"] || "").includes("Master")
      })
    } catch (_) {
      return null
    }
  }

  constructor({ sub, admin, email, firstName, roles }) {
    this.id = sub
    this.admin = admin
    this.email = email
    this.firstName = firstName
    this.role = roles
  }

  get isAdmin() {
    return this.admin
  }
}